import { render, staticRenderFns } from "./ExcelReference.vue?vue&type=template&id=a3452ce6&scoped=true&"
import script from "./ExcelReference.vue?vue&type=script&lang=js&"
export * from "./ExcelReference.vue?vue&type=script&lang=js&"
import style0 from "./ExcelReference.vue?vue&type=style&index=0&id=a3452ce6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3452ce6",
  null
  
)

export default component.exports